<script>
import simplebar from "simplebar-vue";
import SideNav from "./side-nav";
import { mapState } from "vuex";
import { firstRegionalUserPath, canAccessRegionalMenu } from "@/utils/regional-user-permissions";
import { rotuloVersao, estadoVersao, temVersaoNova } from "@/utils/versao";

export default {
  components: { simplebar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60
      },
      versao: estadoVersao,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    homePath() {
      return canAccessRegionalMenu(this.account.user, "/") ? "/" : firstRegionalUserPath(this.account.user);
    },
    rotuloVersao() {
      return rotuloVersao();
    },
    // Reativo via estadoVersao (Vue.observable): o "Nova" some ao abrir /novidades.
    versaoNova() {
      return this.versao && temVersaoNova();
    },
    avatarUrl() {
      const u = this.account.user || {};
      return u.avatar || "https://ui-avatars.com/api/?background=27416E&color=fff&name=" + encodeURIComponent(u.name || "");
    },
  },
  methods: {
    // Gaveta do celular: a sidebar agora ocupa a altura toda (cobre o topo),
    // então ela precisa do próprio botão de fechar.
    fecharGaveta() {
      document.body.classList.remove("sidebar-enable");
    },
  }
};
</script>

<template>
  <div class="vertical-menu">
    <!-- Marca + versão (referência: Acelerador). Fora do <nav>/<ul> do side-nav
         de propósito: o realce do item ativo percorre aquela árvore na mão. -->
    <div class="sidebar-brand">
      <router-link :to="homePath" class="sidebar-brand-logo" aria-label="Sales Teams — início">
        <img class="sidebar-logo-full sidebar-logo-light" src="@/assets/images/logo.png" alt="" />
        <img class="sidebar-logo-full sidebar-logo-dark" src="@/assets/images/logo-white.png" alt="" />
        <img class="sidebar-logo-icon" src="@/assets/images/logo-icon.png" alt="" />
      </router-link>
      <router-link to="/novidades" class="sidebar-version" :title="'Novidades da versão ' + rotuloVersao">
        <span class="sidebar-version-dot" :class="{ 'is-new': versaoNova }" aria-hidden="true"></span>
        <span>{{ rotuloVersao }}</span>
        <span v-if="versaoNova" class="sidebar-version-new">Nova</span>
      </router-link>
      <button type="button" class="st-icon-btn sidebar-close d-lg-none" aria-label="Fechar menu" @click="fecharGaveta">
        <i class="bx bx-x" aria-hidden="true"></i>
      </button>
    </div>

    <simplebar v-if="!isCondensed" :settings="settings" class="sidebar-scroll">
      <SideNav />
    </simplebar>

    <simplebar v-else class="sidebar-scroll">
      <SideNav />
    </simplebar>

    <div v-if="account.user && account.user.name" class="sidebar-user-card">
      <img class="sidebar-user-avatar" :src="avatarUrl" alt="" />
      <div class="sidebar-user-info">
        <div class="sidebar-user-name">{{ account.user.name }}</div>
        <router-link tag="a" to="/logout" class="sidebar-user-logout">Sair</router-link>
      </div>
    </div>
  </div>
</template>
